<script lang="ts">
	let { eyebrow, title, lead }: { eyebrow: string; title: string; lead?: string } = $props();
</script>

<header class="relative overflow-hidden border-b border-border/70">
	<div
		class="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full blur-3xl"
		style="background: radial-gradient(circle, rgb(0 122 255 / 0.08), transparent 62%)"
	></div>
	<div class="mx-auto max-w-4xl px-5 py-16">
		<p class="font-mono text-xs uppercase tracking-widest text-accent">{eyebrow}</p>
		<h1 class="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
		{#if lead}
			<p class="mt-4 max-w-2xl text-lg text-fg-muted">{lead}</p>
		{/if}
	</div>
</header>
